<template>
  <div>
    <vs-button
      class="mt-2"
      color="primary"
      type="border"
      icon-pack="feather"
      icon="icon-plus"
      @click="handleCreate()"
      >Create</vs-button
    >
    <div class="vx-row mb-12">
      <div v-bind:class="[action ? detailShow : '', detailHide]">
        <vs-table
          search
          stripe
          border
          description
          :sst="true"
          :data="table.data"
          :max-items="table.length"
          :total="table.total"
          @search="handleSearch"
          @change-page="handleChangePage"
          @sort="handleSort"
        >
          <template slot="header">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div
                class="p-3 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
              >
                <span class="mr-2"
                  >{{ this.table.start }} - {{ this.table.end }} of
                  {{ this.table.total }}</span
                >
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <vs-dropdown-menu>
                <vs-dropdown-item
                  v-for="item in table.limits"
                  :key="item"
                  @click="handleChangelength(item)"
                >
                  <span>{{ item }}</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </template>
          <template slot="thead">
            <vs-th width="10%"></vs-th>
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="role">Role</vs-th>
            <vs-th sort-key="indicator">Indicator</vs-th>
            <vs-th sort-key="version">Version</vs-th>
            <vs-th sort-key="year">Year</vs-th>
            <vs-th sort-key="total_target">Target</vs-th>
            <vs-th sort-key="uplift">Uplift</vs-th>
            <vs-th sort-key="total_cascade">Cascade</vs-th>
            <vs-th sort-key="description">Description</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td class="whitespace-no-wrap">
                <vs-button
                  v-if="data[indextr].status == 0"
                  @click.stop="handleDistribute(data[indextr].id)"
                  size="small"
                  >Distribute</vs-button
                >
                <vs-button
                  v-else
                  @click.stop="handleDistribute(data[indextr].id)"
                  size="small"
                  >Detail</vs-button
                >
                <feather-icon
                  v-if="data[indextr].level == 0"
                  title="Edit"
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  class="ml-2"
                  @click.stop="handleEdit(data[indextr].id)"
                />
                <feather-icon
                  v-if="data[indextr].level == 0"
                  title="Delete"
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-2"
                  @click.stop="handleDelete(data[indextr].id)"
                />
              </vs-td>
              <vs-td>{{ data[indextr].name }}</vs-td>
              <vs-td>{{ data[indextr].role }}</vs-td>
              <vs-td>{{ indicator(data[indextr]) }}</vs-td>
              <vs-td>{{ data[indextr].version }}</vs-td>
              <vs-td>{{ data[indextr].year }}</vs-td>
              <vs-td>{{ formatPrice(data[indextr].total_target) }}</vs-td>
              <vs-td>{{ data[indextr].uplift }}%</vs-td>
              <vs-td>{{ formatPrice(data[indextr].total_cascade) }}</vs-td>
              <vs-td>{{ data[indextr].description }}</vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <vs-pagination
          style="padding-top: 5px"
          :total="table.totalPage"
          v-model="setPage"
        />
      </div>
      <!-- form -->
      <transition name="detail-fade">
        <div
          v-if="action"
          v-bind:class="[action ? detailShow : '', detailHide]"
        >
          <vs-row>
            <vs-col
              style="padding-bottom: 8px"
              vs-offset="8"
              vs-type="flex"
              vs-justify="rigth"
              vs-align="rigth"
              vs-w="4"
            >
              <vs-button
                class="ml-auto"
                size="small"
                v-on:click="handleClose"
                color="grey"
                icon-pack="feather"
                icon="icon-x-square"
                >Close</vs-button
              >
            </vs-col>
            <vs-col
              class="vertical-divider"
              vs-offset="0"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="1"
            >
              <vs-button
                size="small"
                v-on:click="handleClose"
                color="grey"
                icon-pack="feather"
                icon="icon-x-square"
              ></vs-button>
            </vs-col>
            <!-- form component -->
            <target-form
              v-if="action == 'edit' || action == 'create'"
              @close="handleClose"
              :id="id"
              :baseUrl="baseUrl"
              :title="title"
              :action="action"
            ></target-form>
          </vs-row>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import TargetForm from "./TargetForm";
export default {
  components: {
    TargetForm,
  },
  data() {
    return {
      title: "Target",
      baseUrl: "/api/v1/master/target-management",
      detailShow: "core vx-col md:w-1/2 w-full mb-base ",
      detailHide: "core vx-col md:w-1/1 w-full mb-base ",
      action: "",
      id: null,
      table: this.tableState(),
    };
  },
  methods: {
    tableState() {
      return {
        data: [],
        length: 10,
        page: 1,
        search: "",
        order: "id",
        sort: "desc",
        total: 0,
        totalPage: 0,
        totalSearch: 0,
        limits: [10, 25, 50, 100, "All"],
        start: 1,
        end: 0,
      };
    },
    handleSearch(searching) {
      this.table.search = searching;
      this.table.page = 1;
      this.getData();
    },
    handleChangePage(page) {
      this.table.page = page;
      this.getData();
    },
    handleSort(key, active) {
      if (active) {
        this.table.order = key;
        this.table.sort = active;
      } else {
        this.table.order = "id";
        this.table.sort = "desc";
      }
    },
    handleChangelength(val) {
      this.table.length = val == "All" ? this.table.total : val;
      this.table.page = 1;
      this.getData();
    },
    handleClose() {
      this.getData();
      this.action = "";
    },
    handleCreate() {
      this.id = null;
      this.action = "create";
    },
    handleDetail(val) {
      this.id = val;
      this.action = "detail";
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get(this.baseUrl, {
          params: {
            length: this.table.length,
            page: this.table.page,
            search: this.table.search,
            order: this.table.order,
            sort: this.table.sort,
          },
        })
        .then((resp) => {
          if (resp.status == "success") {
            this.table.total = resp.data.total_record;
            this.table.totalPage = resp.data.total_page;
            this.table.totalSearch = resp.data.total_record_search;
            this.table.length = resp.data.total_record_per_page;
            this.table.data = resp.data.records;
            this.setStartEnd();
            this.$vs.loading.close();
          } else {
            console.log(resp.data);
          }
        });
    },
    setStartEnd() {
      let valStart =
        this.table.length * this.table.page - this.table.length + 1;
      if (valStart > this.table.total) {
        valStart = 1;
      }
      if (this.table.total == 0) {
        valStart = 0;
      }
      let valEnd = this.table.length * this.table.page;
      if (valEnd > this.table.total) {
        valEnd = this.table.total;
      }
      if (this.table.totalSearch < this.table.total) {
        valEnd = this.table.totalSearch;
      }

      this.table.start = valStart;
      this.table.end = valEnd;
    },
    handleDelete(value) {
      this.detail = false;
      this.id = value;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Please confirm to delete this data",
        accept: this.acceptDelete,
      });
    },
    acceptDelete() {
      this.$vs.loading();
      this.$http
        .delete(this.baseUrl + "/" + this.id)
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: "The data was successfully deleted",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
          this.getData();
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    handleEdit(value) {
      this.id = value;
      this.action = "edit";
    },
    handleDistribute(val) {
      this.$router.push({
        name: "distribute",
        params: { id: val },
      });
    },
    formatPrice(val) {
      val = (val / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    indicator(val) {
      let indicator = "";
      switch (val.indicator) {
        case "General":
          indicator = val.indicator;
          break;
        case "Distribution Channel":
          indicator = val.indicator + " (" + val.customer_category_name + ")";
          break;
        case "Product Category":
          indicator = val.indicator + " (" + val.product_category_name + ")";
          break;
        case "Product Brand":
          indicator = val.indicator + " (" + val.product_brand_name + ")";
          break;
        case "Product":
          indicator = val.indicator + " (" + val.product_name + ")";
          break;
        case "Sales Channel":
          indicator = val.indicator + " (" + val.sales_channel_name + ")";
          break;
        case "Territory Area":
          indicator =
            val.indicator +
            " (" +
            val.territory_area_code +
            " " +
            val.territory_area_name +
            ")";
          break;
      }

      return indicator;
    },
  },
  mounted() {
    // this.getData();
  },
  computed: {
    setPage: {
      get() {
        return 1;
      },
      set(val) {
        this.handleChangePage(val);
      },
    },
  },
};
</script>

 <style scoped>
.core-enter-active {
  transition: all 0.3s ease;
}
.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.core-enter, .core-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.core {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}
.vertical-divider {
  border-left: 1px solid #7367f0;
  min-height: 800px;
  padding: 5px;
}
</style>